import "./lib/sentry";
import "@fontsource-variable/inter";

// import "./lib/wdyr";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./lib/dayjs";
import "./styles.css";

import App from "./app/app";
import { hasElectronTitlebar } from "./lib/electron";

if (hasElectronTitlebar()) {
  document.documentElement.classList.add("electron-titlebar");
}

const container = document.getElementById("root");
if (!container) throw new Error("container not found!");
const root = createRoot(container);

root.render(
  <StrictMode>
    <App />
  </StrictMode>,
);
